/// <reference path="../media.d.ts.ts" />

import { BrowserMultiFormatReader } from "@zxing/library/es2015"
import { IScannerCode, IScanOptions } from "./Abstraction/IScanner";
import { BaseCameraScanner, IBaseCameraScannerOptions } from "./BaseCameraScanner";
import { addClass, delayAsync, element, removeClass } from "./Utils";
import { createElement, ReactElement, ReactNode } from "react";
import CameraScannerPreview from "./Components/CameraScannerPreview";

export class ZXingScanner extends BaseCameraScanner {

    protected _reader: BrowserMultiFormatReader;
    protected _scanPromise: Promise<void>;


    constructor(options?: IBaseCameraScannerOptions) {
        super(options);
        this._reader = new BrowserMultiFormatReader();
    }

    /**************************************/

    protected getVideoWork() {
        return element<HTMLVideoElement>("#preview");
    }

    /**************************************/

    protected async openWorkAsync() {
      
    }

    /**************************************/

    protected async showScannerAsync() {

        console.debug("showScannerAsync");

        const preview = element(".scan-preview");
        removeClass(preview, "hidden");

        await delayAsync();
        addClass(preview, "visible");
    }

    /**************************************/

    protected async hideScannerAsync() {

        const preview = element(".scan-preview");

        if (preview) {

            removeClass(preview, "visible");

            await delayAsync(500);

            if (!this._isScanning)
                addClass(preview, "hidden");
        }
    }

    /**************************************/

    protected async startScanAsync() {

        console.debug("startScanAsync");

        this._isScanning = true;

        await this.showScannerAsync();

        setTimeout(async () => {

            await this.waitForScannerAsync();

            console.debug("Scanner Ready");

            if (this._isScanning)
                await this.updateCapsAsync();
        });
    }

    /**************************************/

    async scanSingleAsync(options?: IScanOptions) {

        console.debug("START scanSingleAsync");

        let scanResolve: () => void;

        this._scanPromise = new Promise(res => scanResolve = res);

        let scanCode: IScannerCode;

        if (isNaN(this._activeCamera) || this._activeCamera < 0 || this._activeCamera >= this._cameras?.length)
            this._activeCamera = 0;

        while (true) {

            await this.startScanAsync();

            const curCamera = this._activeCamera;

            console.log("Active camera: ", curCamera);

            const video = this.getVideo(true);

            try {

                const result = await this._reader.decodeOnceFromVideoDevice(this._cameras[curCamera].deviceId, video);

                console.debug("RESULT scanSingleAsync");

                if (result) {
                    scanCode = {
                        type: result.getBarcodeFormat().toString(),
                        code: result.getText()
                    };
                }
                break;
            }
            catch (ex) {
                console.warn("decodeOnceFromVideoDevice: ", ex);
                if (curCamera == this._activeCamera)
                    break;
            }
        }

        console.debug("STOPPING scanSingleAsync");

        await this.stopScanAsync(false);

        if (scanResolve)
            scanResolve();

        console.debug("DONE scanSingleAsync");

        return scanCode;
    }

    /**************************************/

    async startMultiScanAsync(onResult: (result: IScannerCode) => Promise<boolean>, options?: IScanOptions) {

        await this.startScanAsync();

        try {

            await this._reader.decodeFromInputVideoDeviceContinuously(this._cameras[this._activeCamera].deviceId, "preview", async result => {

                if (!result)
                    return;
                 
                const mustContinue = onResult({
                    type: result.getBarcodeFormat().toString(),
                    code: result.getText()
                });

                if (!mustContinue)
                    this.stopScanAsync();
            });

        }
        catch (ex) {
            console.log(ex);
        }
    }

    /**************************************/

    async stopScanAsync(wait = true) {

        console.debug("stopScanAsync");

        if (!this._isScanning) {
            console.warn("not scanning");
            return;
        }

        await this.hideScannerAsync();

        this._reader.stopAsyncDecode();
        this._reader.stopContinuousDecode();
        this._reader.reset();

        if (this._scanPromise) {
            if (wait) {
                console.debug("wait scanPromise");
                await this._scanPromise;
            }
            this._scanPromise = null;
        }

        this._isScanning = false;
        console.debug("stopped");
    }

    /**************************************/

    async setCameraAsync(index: number) {

        this._activeCamera = index;

        console.log("Change Active camera: ", this._activeCamera, " of ", this._cameras.length);

        this._reader.stopAsyncDecode();
    }

    /**************************************/

    createPreview(info?: ReactNode, isScanning?: boolean): ReactElement {
        return createElement(CameraScannerPreview, { scanner: this, info, isActive: isScanning, useCanvas: this._useCanvas });
    }
}

